var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.docs),function(doc){return _c('isogd-doc-in-point',{key:doc.key,attrs:{"doc":doc}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }